import { IconPublishOrder } from './vo/Icon-publish-order.model'

/**
 * アイコン掲載順設定画面の値を管理するクラス
 *
 * @export KYMW1509Model
 * @class KYMW1509Model
 */
export class KYMW1509Model {

  public markGroupList = [];
  public selectedMarkGroup = '';
  public beforeChangeSelectedMarkGroup = '';
  public iconListMap = {};
  public displayIconList = []
  public beforeChangeIconList = [];

  /**
   * マークグループリストを更新する
   *
   * @param serverData マークグループリストのサーバ取得データ
   */
  public updateMarkGroupList(serverData: any) {
    this.markGroupList = serverData;
  }

  /**
   * アイコン掲載順VO生成
   *
   * @param icon アイコン
   */
  private newVo(icon: any) {
    return new IconPublishOrder(
      icon.GroupCode,
      icon.IconCode,
      icon.IconName,
      icon.PublishOrder,
      icon.IconFileUrl,
    )
  }

  /**
   * アイコン掲載順リストを更新する
   *
   * @param serverData アイコン掲載順リストのサーバ取得データ
   */
  public updateIconListMap(serverData: any) {
    // グループコンボボックス変更時に取り出しやすいよう整形しておく
    // {グループコード: [アイコン, ...]}
    for (const data of serverData) {
      const icon = this.newVo(data);
      if (icon.groupCode in this.iconListMap) {
        this.iconListMap[icon.groupCode].push(icon);
      } else {
        this.iconListMap[icon.groupCode] = [icon];
      }
    }

    // 掲載順でソートする
    for (const key in this.iconListMap) {
      this.iconListMap[key].sort((a, b) => {
        return Number(a.publishOrder) > Number(b.publishOrder) ? 1 : -1;
      })
    }
  }
}
